module.exports = __webpack_public_path__ + "img/gpy1.694d6e0d.png";